var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "exit_to_app_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/action/exit_to_app_24px",
    d: "M4.16667 2.5H15.8333C16.75 2.5 17.5 3.25 17.5 4.16667V15.8333C17.5 16.75 16.75 17.5 15.8333 17.5H4.16667C3.24167 17.5 2.5 16.75 2.5 15.8333V12.5H4.16667V15.8333H15.8333V4.16667H4.16667V7.5H2.5V4.16667C2.5 3.25 3.24167 2.5 4.16667 2.5ZM9.58333 14.1667L8.40833 12.9917L10.5583 10.8333H2.5V9.16667H10.5583L8.40833 7.00833L9.58333 5.83333L13.75 10L9.58333 14.1667Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.0feaa67c6cc5b8001baadc7c82fdf397.svg";
export { ForwardRef as ReactComponent };